import items from "../data/items.json";

const getTrendingItems = async () => {
  return items.filter((item) => item.isTrending);
};

const getRemainingItems = async () => {
  return items.filter((item) => !item.isTrending);
};

const getMovies = async () => {
  return filterItemsByCategory("movie");
};

const getSeries = async () => {
  return filterItemsByCategory("tv series");
};

const getBookmarked = async () => {
  return items.filter((item) => item.isBookmarked);
};

const filterItemsByCategory = (str: string) => {
  return items.filter((item) => item.category.toLowerCase() === str);
};

const getQueryItems = async (query: string) => {
  return items.filter((item) =>
    item.title.toLocaleLowerCase().includes(query.toLocaleLowerCase())
  );
};

const API = {
  getTrendingItems,
  getRemainingItems,
  getMovies,
  getSeries,
  getQueryItems,
  getBookmarked,
};

export default API;
